<template>
  <b-container>
    <h1 v-translate>Edit Profile</h1>
    <hr>
    <div class="row">
      <div class="col-md-3">
        <profile-navigation />
      </div>
      <div class="col-md-9 personal-info">
        <b-alert :show="dismissCountDown" dismissible variant="success" @dismissed="dismissCountDown=0" @dismiss-count-down="countDownChanged">
          <p v-translate>The password has been changed!</p>
        </b-alert>
        <form class="" role="form" @submit.prevent="submit">
          <div class="row">
            <h3 class="col-12" v-translate>Change Password</h3>
          </div>
          <div class="row">
            <div class="form-group col-md-6">
              <label class="control-label" v-translate>Old Password</label>
              <b-form-input type="password" v-model="current_password" required></b-form-input>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-6">
              <label class="control-label" v-translate>New Password</label>
              <password ref="pwd_check" :min="passwordMinLength" :placeholder="$gettext('New Password')" v-model="password" inputClass="form-control" @input="validatePassword" @score="newPasswordScore = $event" :min-score="passwordMinScore" />
              <b-form-text id="inputLiveHelp" v-translate="{minLength: passwordMinLength}">%{minLength} characters minimum, must contain upper and lower case letters, numbers and symbols</b-form-text>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-6">
              <label class="control-label" v-translate>Repeat Password</label>
              <b-form-input aria-describedby="inputLiveHelp inputLiveFeedback" :state="samePassword" type="password" v-model="validate.password" @input="validatePassword" autocomplete="new-password" required></b-form-input>
              <b-form-invalid-feedback id="inputLiveFeedback" v-translate>Passwords don't match</b-form-invalid-feedback>
            </div>
          </div>
          <div class="row text-left">
            <div class="form-group col-12 form-actions">
              <label class="col-md-3 control-label"></label>
              <div class="col-md-8">
                <b-button type="submit" variant="primary" size="lg" v-translate>Save Changes</b-button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </b-container>
</template>
<script>
import { CHANGE_PASSWORD } from '@/store/actions.type'
import ProfileNavigation from '@/components/ProfileNavigation'
import Password from '@/components/Password'
export default {
  name: 'ProfileChangePasswordPage',
  title() {
    return this.$gettext('Change Password « Edit Profile')
  },
  components: {
    Password,
    ProfileNavigation
  },
  data() {
    return {
      current_password: '',
      password: '',
      validate: {
        password: ''
      },
      samePassword: null,
      passwordMinLength: 12,
      passwordMinScore: 100,
      newPasswordScore: 0,
      dismissSecs: 10,
      dismissCountDown: 0
    }
  },
  methods: {
    validatePassword() {
      this.samePassword = this.password.length > 0 ? this.password === this.validate.password : null
    },
    submit(e) {
      if (this.$refs.pwd_check.has_length && this.$refs.pwd_check.pwd_score >= 40 && this.samePassword) {
        this.$store.dispatch(CHANGE_PASSWORD, { current_password: this.current_password, new_password: this.password })
          .then(response => {
            this.showAlert()
            this.current_password = ''
            this.password = ''
            this.validate.password = ''
            this.$refs.pwd_check.reset()
            e.target.reset()
          }, error => {
            let obj = {
              title: 'ERROR',
              message: error.body.message,
              type: 'error',
              customCloseBtnText: this.$gettext('Close')
            }
            this.$parent.$refs.simplert.openSimplert(obj)
          })
      }
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    }
  }
}

</script>
